// @ts-nocheck
import {Column} from 'react-table'
import {HotelCustomHeader} from './HotelCustomHeader'
import {Hotel} from '../../core/_models'
import { HotelInfoCell } from '../../../../../../_dashboard/partials/components/commonColumns/HotelCell'
import { HotelActionsCell } from './HotelActionsCell'
import { HotelActiveCell } from './HotelActiveCell'
import { useIntl } from 'react-intl'; 

const hotelsColumns: ReadonlyArray<Column<Hotel>> = [
  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({
          id: 'COLUMNS.EXTERNAL_HOTEL_ID',
          defaultMessage: 'ID externe',
        })}
        className='min-w-125px'
      />
    ),
    id: 'hotel_id',
    accessor: 'hotel_id',
    Cell: ({row}) => {
      const hotel = row.original as any
      const externalId = hotel?.hotel_id
      const display =
        externalId != null && String(externalId).trim() !== ''
          ? String(externalId)
          : '—'
      return <span className='text-gray-800 fw-semibold font-monospace'>{display}</span>
    },
  },
  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <HotelInfoCell hotel={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CATEGORY' })}
        className='min-w-125px'
      />
    ),
    accessor: 'ratings.title',
    Cell: ({ value }: { value: string }) => (
      <span className="text-muted">{value}</span>
    ),
  },
  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CITY' })}
        className='min-w-125px'
      />
    ),
    accessor: 'city.name',
    Cell: ({ value }: { value: string }) => (
      <span className="text-muted">{value}</span>
    ),
  },
  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.ADDRESS' })}
        className='min-w-125px'
      />
    ),
    accessor: 'address',
  },
  {
    Header: (props) => (
      <HotelCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({
          id: 'COLUMNS.HOTEL_ACTIVE',
          defaultMessage: 'Actif',
        })}
        className='min-w-100px'
      />
    ),
    id: 'isActive',
    Cell: ({...props}) => <HotelActiveCell hotel={props.data[props.row.index]} />,
  },
  {
    id: 'actions',
    Cell: ({...props}) => <HotelActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {hotelsColumns}
